<article>
  <div class="time-bar" [nbTooltip]="(this.start | date:'mediumDate') + ' - ' + (this.end ? (this.end | date:'mediumDate') : ('indefinite' | translate))" [style.left]="(this.left * 100) + '%'" [style.width]="(this.width * 100) + '%'" [class.indefinite]="!this.end">
    @for (m of this.marks; track $index; let i = $index) {
      <div class="time-mark" [nbTooltipStatus]="'danger'" [nbTooltip]="this.markers[i].label + ' ' + (this.markers[i].date | date:'mediumDate')" [style.left]="(m * 100) + '%'"></div>
    }
  </div>
</article>
